import React, { useState, useEffect } from "react";
import "./compare.scss";
import {useMediaQuery} from "react-responsive";

const StickyNavbar = ({ primaryVehicle, secondaryVehicle, activeFeatureLabel }) => {
    const [showSticky, setShowSticky] = useState(false);
    const isMobile = useMediaQuery({query: '(max-width: 479px)'})
    const handleScroll = () => {
        if (isMobile){
            setShowSticky(window.scrollY > 380)
        }
        else {
            setShowSticky(window.scrollY > 350);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div>
            {!showSticky && (
                <div id={"feature-fixed-header"} className={"feature-segment-label"}>
                    <div className={"header-title"}>{activeFeatureLabel}</div>
                </div>
            )}
            <div
                className={`sticky-div ${showSticky ? "show" : ""}`}
                style={showSticky ? { paddingTop: "0" } : {}}
            >
                <div className="sticky-container">
                    <div className="sticky-column">
                        <div className={"vehicle-desc"}>{primaryVehicle?.description}</div>
                    </div>
                    <div className="sticky-column">
                        <div className={"vehicle-desc"}>{secondaryVehicle?.description}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StickyNavbar;
